import { Network } from '@capacitor/network'
import { useToasted } from '@hoppscotch/vue-toasted'

let notice;
let networkListener;

async function cleanup() {
  if (networkListener) {
    await networkListener.remove()
    networkListener = null
  }

  if (notice) {
    notice.goAway(0)
    notice = null
  }
}

export default {
  ensureNetwork: async function (callback) {
    let { connected } = await Network.getStatus()
    const toasted = useToasted()

    return new Promise( (resolve, reject) => {
      cleanup()
        .catch(e => reject(e))

      if (connected) {
        resolve(callback ? callback() : undefined);
      } else {
        // create a new notice and reference it
        notice = toasted.show('No network connection!', {
          duration: 0,
          position: 'top-center'
        })

        // add a new listener
        Network.addListener('networkStatusChange', ({ connected: connectedNow }) => {
          // not dry, but resolves issues with recursion and resolving original promise
          if (connectedNow) {
            cleanup()
              .catch(e => reject(e))

            // resolve original promise
            resolve(callback ? callback() : undefined)
          }
        }).then(listener => {
          networkListener = listener
        }).catch(e => {
          cleanup()
            .catch(e => reject(e))
          reject(e)
        })
      }
    })
  }
}
